export default __webpack_public_path__ + "static/media/hotel_jp_3.31003090.jpeg";